import { useQuery, gql, useReactiveVar } from '@apollo/client';
import { appLanguage } from "../reactive-variables";

const GET_VACANCIES = gql`
    query GetVacancies {
        vacancy {  
            id
            title
            description
            image_url
            salary
            created_at
            slug
            cvIsRequired
        }
    }
`;

export const useVacancies = () => {
    const language = useReactiveVar(appLanguage);

    const { data, loading, error } = useQuery(GET_VACANCIES, {
        context: {
            headers: {
                "accept-language": language
            }
        }
    });

    if (error) {
        console.error("GraphQL Error:", error);
    }

    console.log(data,'data');
    return { data: data?.vacancy, loading };
};
